module.exports = __webpack_public_path__ + "static/media/Dashboard.b8552436.svg";